import { useQuery } from '@tanstack/react-query';
import { getStaticPages, type StaticPage } from '../api/staticPages';

/** Fetches the page list for a static sub-project. Cached per slug. */
export function useStaticPages(slug: string | undefined) {
  return useQuery<StaticPage[]>({
    queryKey: ['static-pages', slug],
    queryFn: () => getStaticPages(slug as string),
    enabled: Boolean(slug),
    staleTime: 60_000,
    retry: false,
  });
}
